<template>
  <AppDashboardNumericData
    :title="$t('APP.STATS.REVIEWS.TOTAL_RATING')"
    :icon="require('@/assets/images/user-rating.svg')"
    :loading="loading"
    class="app-dashboard-numeric-data"
  >
    <ElRate :value="rating" disabled text-color="#ff9900" />
    <span class="app-dashboard-numeric-data__score">{{ rating }}</span>
  </AppDashboardNumericData>
</template>

<script>
import AppDashboardNumericData from './AppDashboardNumericData';
import Reviews from '@/api/app-reviews';

export default {
  name: 'AppDashboardRatingData',
  components: { AppDashboardNumericData },
  props: {
    packageName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      rating: 0,
      loading: true,
    };
  },
  watch: {
    packageName: {
      immediate: true,
      handler() {
        this.getAppTotalRating();
      },
    },
  },
  methods: {
    getAppTotalRating() {
      this.loading = true;

      return Reviews.getRateSummary(this.packageName)
        .then(({ rate }) => {
          this.rating = rate;
          this.loading = false;
        })
        .catch(({ message }) => {
          this.$message.error(message);
        });
    },
  },
};
</script>

<style lang="scss">
.app-dashboard-numeric-data {
  &__score {
    margin-left: $global-margin;

    @include rtl() {
      margin-left: 0;
      margin-right: $global-margin;
    }
  }
}
</style>
